import { Component } from "react";
import View from "./view";
import { withRouter } from "react-router-dom";
import { getMachineFromId, updateMachine } from "../../backend/machine";
import "./index.css";
import moment from "moment";

class UpdateMachine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      updateSuccess: false,
      machine: {
        serial_number: "",
        code: "",
        machine_hours: "",
        test_date: moment().format("YYYY-MM-DD"),
        hire_status: ""
      },
      errMsg: ""
    };

    this._submit = this._submit.bind(this);
    this._updateMachine = this._updateMachine.bind(this);
    this.machineId = props.match.params.id;
  }

  async componentDidMount() {
    this.setState({ machine: await getMachineFromId(this.machineId) });
  }

  _updateMachine(value) {
    this.setState({ machine: { ...this.state.machine, ...value } });
  }

  async _submit() {
    this.setState({ loading: true, errMsg: "" });
    const { machine } = this.state;

    machine.test_date = moment().format("YYYY-MM-DD HH:mm:ss");

    let rtn = await updateMachine({ machine });

    if (rtn.success === 1) {
      this.setState({ updateSuccess: true, loading: false });
    } else {
      this.setState({
        updateSuccess: false,
        loading: false,
        errMsg: rtn.error.msg
      });
    }
  }

  render() {
    return View.call(this);
  }
}

export default withRouter(UpdateMachine);



// WEBPACK FOOTER //
// ./src/screens/update/index.js